<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import PatientAddEditForm from "@/components/models/patient/forms/PatientAddEditForm.vue";
import { useAbility } from "@casl/vue";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.patient" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PATIENT__PATIENT);
    },
  },
});
</script>

<template>
  <v-skeleton-loader>
    <patient-add-edit-form />
  </v-skeleton-loader>
</template>

<style scoped></style>
